import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store'

Vue.use(VueRouter)

/*
 Roles disponibles
 1 - Despachador
 2 - Pickeador
 3 - Administrador
 4 - Inventariador
 5 - Administrador Inventario
 6 - Monitor
 */
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    props: { modo: 'picking' },
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [1, 2, 3, 6]
    }
  },
  {
    path: '/despacho',
    name: 'despacho',
    component: Home,
    props: { modo: 'despacho' },
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [1, 3, 6]
    }
  },
  {
    path: '/posteriores',
    name: 'posteriores',
    component: Home,
    props: { modo: 'posterior' },
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [1, 3, 6, 7]
    }
  },
  {
    path: '/pedidos-zona',
    name: 'pedidosZona',
    component: () =>
      import(/* webpackChunkName: "monitorZona" */ '../views/PedidosZona.vue'),
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [1, 3, 6, 7]
    }
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: () =>
      import(/* webpackChunkName: "clientes" */ '../views/Clientes.vue'),
    meta: {
      showNavigation: true
    }
  },
  {
    path: '/configurador/:id',
    name: 'configurador',
    component: () =>
      import(
        /* webpackChunkName: "configurador" */ '../views/Configurador.vue'
      ),
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [1, 2, 3]
    }
  },
  {
    path: '/pedido/:id?',
    name: 'visor',
    component: () =>
      import(/* webpackChunkName: "visor" */ '../views/Visor.vue'),
    props: { modo: 'picking' },
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [1, 2, 3, 6, 7]
    }
  },
  {
    path: '/entrega/:id?',
    name: 'visor-entrega',
    component: () =>
      import(/* webpackChunkName: "visor" */ '../views/Visor.vue'),
    props: { modo: 'despacho' },
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [1, 3, 6, 7]
    }
  },
  {
    path: '/cierre/:id?',
    name: 'cierrePedido',
    component: () =>
      import(
        /* webpackChunkName: "cierre-pedido" */ '../components/cierre/CierrePedido.vue'
      ),
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [1, 3, 6]
    }
  },
  {
    path: '/disponibilidad',
    name: 'disponibilidad',
    component: () =>
      import(
        /* webpackChunkName: "disponibilidad" */ '../views/Disponibilidad.vue'
      ),
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [1, 2, 3]
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/no-configurado',
    name: 'usuarioNoExiste',
    component: () => import('../views/UsuarioNoExiste.vue'),
    query: {
      tries: 0
    }
  },
  {
    path: '/no-autorizado',
    name: 'usuarioSinAutorizacion',
    component: () => import('../views/UsuarioNoAutorizado.vue'),
    meta: {
      showNavigation: true,
      requiresAuth: true
    },
    query: {
      tries: 0
    }
  },
  {
    path: '/mantenedor/:mantenedor/:id?',
    name: 'mantenedor',
    component: () =>
      import(/* webpackChunkName: "mantenedor" */ '../views/Mantenedor.vue'),
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [3, 6, 7]
    }
  },
  {
    path: '/inventario/:accion/:id?',
    name: 'inventario',
    component: () =>
      import(/* webpackChunkName: "inventario" */ '../views/Inventario.vue'),
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [5, 3]
    }
  },
  {
    path: '/dashboard/:dashboard?',
    name: 'dashboard',
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
    meta: {
      showNavigation: true,
      requiresAuth: true,
      authorize: [1, 2, 3, 4, 5, 6]
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// Validar usuario autentificado
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const estaAutentificado = store.getters['sesion/estaAutentificado']
    if (estaAutentificado) {
      const bodega = store.getters['sesion/bodega']
      const roles = bodega.roles.map((item) => item.id)
      /*
        Roles disponibles
         1 - Despachador
         2 - Pickeador
         3 - Administrador
         4 - Inventariador
         5 - Administrador Inventario
         6 - Monitor
         7 - Jefe de Bodega
       */
      const { requiresAuth = false, authorize = [] } = to.meta
      if (requiresAuth) {
        // Se valida que rol tenga autorización para ingresar a aplicación
        if (
          authorize.length > 0 &&
          roles.every((item) => !authorize.includes(item))
        ) {
          next('/no-autorizado')
          return
        } else {
          next()
          return
        }
      } else {
        next()
        return
      }
    }
    const returnUrl = encodeURIComponent(to.fullPath)
    if (!store.state.sesion.esValida) next(`/login?returnUrl=${returnUrl}`)
    else
      store
        .dispatch('sesion/refreshToken')
        .then(() => {
          next()
        })
        .catch((_) => next(`/login?returnUrl=${returnUrl}`))
  } else {
    next()
  }
})

export default router
